;(function () {
	const controlMegaMenu = (header) => {
		// Find menus in both top and bottom sections
		const topMenu = header.querySelector('.header__inline-menu')
		const bottomMenu = header.querySelector('.header__bottom-inner.container ul')
		const menuUls = []
		
		if (topMenu) {
			const topUl = topMenu.querySelector('ul')
			if (topUl) menuUls.push(topUl)
		}
		if (bottomMenu) menuUls.push(bottomMenu)
		
		if (!menuUls.length) return

		// Process each menu ul
		menuUls.forEach((menuUl) => {
			const menuItems = menuUl.querySelectorAll(':scope > li')
			if (!menuItems || !menuItems.length) return

			// Process each li to check if it has a mega menu
			menuItems.forEach((li, index) => {
				// Check if this li has the mega menu class
				if (!li.classList.contains('list-menu--megamenu')) return

				// Check if it has a mega menu div
				const megaMenu = li.querySelector('.header__mega-menu, .mega-menu')
				if (!megaMenu) return

				// Store the index for debugging/reference
				li.dataset.menuIndex = index

				// Add hover event listeners
				const onMouseEnter = () => {
					li.classList.add('list-menu--megamenu-visible')
				}

				const onMouseLeave = () => {
					li.classList.remove('list-menu--megamenu-visible')
				}

				li.addEventListener('mouseenter', onMouseEnter)
				li.addEventListener('mouseleave', onMouseLeave)

				// Also handle the mega menu itself
				megaMenu.addEventListener('mouseenter', onMouseEnter)
				megaMenu.addEventListener('mouseleave', onMouseLeave)
			})
		})
	}

	const calcMegaMenuPosition = (header) => {
		const isBottomMenuType = Boolean(header.querySelector("header.header--bottom-menu"))
		if (!isBottomMenuType) return

		// Find the header bottom inner container
		const headerBottomInner = header.querySelector('.header__bottom-inner.container')
		if (!headerBottomInner) return

		// Get the ul inside the container
		const menuUl = headerBottomInner.querySelector('ul')
		if (!menuUl) return

		// Get all li elements with mega menu
		const menuItems = menuUl.querySelectorAll(':scope > li.list-menu--megamenu')
		if (!menuItems || !menuItems.length) return

		const headerBottom = header.querySelector('.header__bottom')
		if (!headerBottom) return

		const headerBottomRect = headerBottom.getBoundingClientRect()

		menuItems.forEach((li) => {
			const menuLi = li.querySelector('.header__mega-menu')
			const headerLi = li.querySelector('.header__menu-item')

			if (!menuLi || !headerLi) return

			const headerRect = headerLi.getBoundingClientRect()

			const verticalDistance = Math.abs(
				headerRect.bottom - headerBottomRect.bottom
			)

			menuLi.style.top = `calc(100% - ${verticalDistance}px)`
		})
	}

	const controlMegaSubmenu = (header) => {
		// Find menus in both top and bottom sections
		const topMenu = header.querySelector('.header__inline-menu')
		const bottomMenu = header.querySelector('.header__bottom-inner.container ul')
		const menuUls = []
		
		if (topMenu) {
			const topUl = topMenu.querySelector('ul')
			if (topUl) menuUls.push(topUl)
		}
		if (bottomMenu) menuUls.push(bottomMenu)
		
		if (!menuUls.length) return

		// Process each menu ul
		menuUls.forEach((menuUl) => {
			const menuItems = menuUl.querySelectorAll(':scope > li')
			if (!menuItems || !menuItems.length) return

			// Process each li to check if it has a mega submenu
			menuItems.forEach((li, index) => {
				// Check if this li has the mega submenu class
				if (!li.classList.contains('list-menu--megasubmenu')) return

				// Check if it has a mega submenu div
				const megaSubmenu = li.querySelector('.mega-submenu')
				if (!megaSubmenu) return

				// Store the index for debugging/reference
				li.dataset.submenuIndex = index

				// Add hover event listeners
				const onMouseEnter = () => {
					li.classList.add('list-menu--megasubmenu-visible')
				}

				const onMouseLeave = () => {
					li.classList.remove('list-menu--megasubmenu-visible')
				}

				li.addEventListener('mouseenter', onMouseEnter)
				li.addEventListener('mouseleave', onMouseLeave)

				// Also handle the mega submenu itself
				megaSubmenu.addEventListener('mouseenter', onMouseEnter)
				megaSubmenu.addEventListener('mouseleave', onMouseLeave)

				// Handle tabs in mega submenu
				const tabs = li.querySelectorAll('.mega-submenu__tab')
				const submenus = li.querySelectorAll('.mega-submenu__submenu')

				if (tabs.length === 0 || submenus.length === 0) return

				const onToggle = (event) => {
					// Handle both click and hover on tab links
					const tab = event.target.closest('.mega-submenu__tab')
					if (!tab) return
					
					// Prevent navigation on tab click/hover - tabs should switch content, not navigate
					if (event.type === 'click') {
						event.preventDefault()
						event.stopPropagation()
					}
					
					const tabId = tab.dataset.tabId
					if (!tabId) return

					tabs.forEach((t) => {
						t.classList.remove('active')
					})
					tab.classList.add('active')
					submenus.forEach((submenu) => {
						submenu.classList.remove('active')
						if (submenu.dataset.tabId === tabId) {
							submenu.classList.add('active')
						}
					})
				}
			
				tabs.forEach((tab) => {
					tab.addEventListener('click', onToggle)
					tab.addEventListener('mouseenter', onToggle)
				})
			})
		})
	}

	const checkMegaSubmenuPosition = (header) => {
		const megaSubmenuLinks = header.querySelectorAll('.list-menu--megasubmenu')
		const headerRect = header.getBoundingClientRect();

		megaSubmenuLinks.forEach((link) => {
			const megaSubmenu = link.querySelector('.mega-submenu')
			megaSubmenu.style.removeProperty("max-width");

			const linkRect = link.getBoundingClientRect();
			const availableWidth = headerRect.right - linkRect.left
			if (availableWidth < 1000) {
				megaSubmenu.style.maxWidth  = `calc(${availableWidth}px - 16px)`;
			}
		});
	};

	const calcHeaderHeightTop = (header) => {
		const headerTop = document.querySelector('.shopify-section-header .header__top');
		if (!headerTop) return;

		const headerTopHeight = header.getBoundingClientRect().height.toFixed(4);
		document.documentElement.style.setProperty('--header-height-top', `${headerTopHeight}px`);
	}

	const calcSearchModalPosition = (header) => {
		const headerWrapper = header.querySelector('.header-wrapper ');
		const searchEl = header.querySelector('.header__search.search');
		const searchModal = searchEl.querySelector('.search__modal');
		if (!headerWrapper || !searchEl || !searchModal) return;

		searchModal.style.removeProperty("left");

		const searchElRect = searchEl.getBoundingClientRect();
		const searchModalRect = searchModal.getBoundingClientRect();
		const headerRect = headerWrapper.getBoundingClientRect();

		if (window.innerWidth >= 1100 && searchModalRect.right > headerRect.right) {
			const searchElCenter = searchElRect.left + searchElRect.width / 2;
			const desiredLeft = searchElCenter - searchModalRect.width / 2;

			let finalLeft = desiredLeft;

			if (finalLeft < headerRect.left) {
				finalLeft = headerRect.right - searchModalRect.width;
			}

			const offsetLeft = finalLeft - searchElRect.left;
			searchModal.style.left = `${offsetLeft}px`;
		}
	}

	const initHeader = () => {
		const header = document.querySelector(".shopify-section-header")
		if (!header) return

		controlMegaMenu(header)
		controlMegaSubmenu(header)

		const observer = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				calcMegaMenuPosition(header);
				checkMegaSubmenuPosition(header);
				calcHeaderHeightTop(header);
				calcSearchModalPosition(header);
			});
		});

		observer.observe(header);
	}

	document.addEventListener('DOMContentLoaded', initHeader)
	document.addEventListener('shopify:section:load', initHeader)
})()
